import * as ANS from './action-names.js'
import { fromNullable } from 'data.maybe'

// getHeaderMap
export default ({ getSelectedBounds, getHeaders, getData }) => {
  const pasteData = payload => (dispatch, getState) => {
    const state = getState()
    const bounds = getSelectedBounds(state)
    const headers = getHeaders(state)
    const currentData = getData(state)
    const { data, isCellEditable } = payload
    const boundWidth = bounds.x2 - bounds.x1 + 1
    const boundHeight = bounds.y2 - bounds.y1 + 1

    const pasteData = {}

    for (
      let rowIndex = bounds.y1 - 1, rIdx = 0;
      rowIndex < currentData.length &&
      (rIdx < data.length || rIdx < boundHeight);
      rowIndex++, rIdx++
    ) {
      const copiedRow = data[rIdx % data.length]
      for (
        let columnIndex = bounds.x1, cIdx = 0;
        columnIndex <= headers.length &&
        (cIdx < copiedRow.length || cIdx < boundWidth);
        columnIndex++, cIdx++
      ) {
        if (isCellEditable(rowIndex + 1, columnIndex, state)) {
          const pasteRecord = fromNullable(pasteData[rowIndex]).getOrElse({
            updateData: {},
            currentData: currentData[rowIndex],
          })

          if (!pasteData[rowIndex]) pasteData[rowIndex] = pasteRecord

          pasteRecord.updateData[headers[columnIndex]] =
            copiedRow[cIdx % copiedRow.length]
        }
      }
    }

    dispatch({ type: ANS.PASTE_DATA, payload: { pasteData, headers } })
  }

  return {
    pasteData,
  }
}
export const setEditContent = payload => ({
  type: ANS.SET_EDIT_CONTENT,
  payload,
})
export const cancelEdit = _ => ({ type: ANS.CANCEL_EDIT })
export const commitEdit = payload => ({ type: ANS.COMMIT_EDIT, payload })
export const setContent = payload => ({ type: ANS.SET_CONTENT, payload })
export const clearDirty = _ => ({ type: ANS.CLEAR_DIRTY })
export const selectionStarts = selection => ({
  type: ANS.SELECTION_STARTS,
  payload: selection,
})
export const selectionEnds = selection => ({
  type: ANS.SELECTION_ENDS,
  payload: selection,
})
export const selectionExpands = selection => ({
  type: ANS.SELECTION_EXPANDS,
  payload: selection,
})
export const setSelection = selection => ({
  type: ANS.SET_SELECTION,
  payload: selection,
})
export const startEdit = payload => (dispatch, getState) => {
  const { isCellEditable, rowIndex, columnIndex } = payload

  if (!isCellEditable || isCellEditable(rowIndex, columnIndex, getState()))
    dispatch({ type: ANS.START_EDIT, payload })
}
